<app-skill-builder-select-list
	[mainTitle]="page.title"
	[options]="options"
	[next]="next"
>
</app-skill-builder-select-list>
